import axios from "axios";
import React, { useEffect, useState } from "react";

import ContentLoader from "../../../../Screen/ContentLoader";
import "./EnrollAudition.css";
import SingleEnrollAudition from "./SingleEnrollAudition";
import NodataAvailable from "../../../Common/NodataAvailable";
const EnrollAudition = () => {
  const [auditions, setAuditions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get("api/user/audition/enrolled").then((res) => {
      if (res.data.status === 200) {
        setAuditions(res.data.enrolledAuditions);
        setLoading(false);
      }
    });
  }, []);

  return (
    <>
      {loading ? (
        <>
          <ContentLoader />
        </>
      ) : (
        <>
          <h2 className="mb-3 mt-3 text-dark fw-bold activitiesBg p-2 btn w-100 text-center">
            Enroll Audition
          </h2>
          {auditions.length === 0 ? (
            <NodataAvailable />
          ) : (
            <div className="row">
              {auditions.map((event, index) => (
                <SingleEnrollAudition
                  key={index}
                  event={event}
                ></SingleEnrollAudition>
              ))}
            </div>
          )}
        </>
      )}
    </>
  );
};

export default EnrollAudition;
